(function () {
    'use strict';

    angular
        .module(app.modules.common.name)
        .factory('Memory', Memory);

    var rMediaAnnotation = /^(\w+)@odata.media(\w+)$/;

    Memory.$inject = ['$resource', app.modules.common.constants.appsettings];
    function Memory($resource, ggSettings) {
        var root = ggSettings.grpapi.root,
            url = root + 'memories(:id)',
            queryByOutingUrl = root + 'outings(:outingId)/memories',
            queryByGroupUrl = root + 'groups(:groupId)/memories';

        return $resource(url, { id: '@id' }, {
            query: { method: 'GET', isArray: true, jsonReviver: jsonReviver, params: { $orderby: 'createdOn desc', $expand: 'createdBy($select=firstName,lastName,photo)' } },
            get: { method: 'GET', jsonReviver: jsonReviver },

            save: { method: 'POST', transformRequest: transformRequest, jsonReviver: jsonReviver },
            update: { method: 'PUT', transformRequest: transformRequest, jsonReviver: jsonReviver },

            queryByOuting: {
                method: 'GET', isArray: true, url: queryByOutingUrl, jsonReviver: jsonReviver,
                params: { $orderby: 'createdOn desc', $expand: 'createdBy($select=firstName,lastName,photo)', $count: true },
                interceptor: { response: transformResponse }
            },
            queryByGroup: {
                method: 'GET', isArray: true, url: queryByGroupUrl, jsonReviver: jsonReviver,
                params: { $orderby: 'createdOn desc', $expand: 'createdBy($select=firstName,lastName,photo)', $count: true },
                interceptor: { response: transformResponse }
            }
        });

        function jsonReviver(key, value) {
            var match = rMediaAnnotation.exec(key);
            if (match) {
                this['$' + match[1] + match[2]] = value;
                return undefined;
            }
            else if (key === 'createdBy') {
                this['$createdBy'] = ((value.firstName || '') + ' ' + (value.lastName || '')).trim() || 'John Doe';
                this['$createdByPhoto'] = value.$photoReadLink;
                this['$initials'] = ((value.firstName || '') == '' ? '' : value.firstName.substring(0, 1)) + '' + ((value.lastName || '') == '' ? '' : value.lastName.substring(0, 1));
                return undefined;
            }
            else if (key === '@odata.count') {
                this.value.$count = value;
            }
            else
                return value;
        }

        function transformRequest(request) {
            return JSON.stringify(request, replacer);

            function replacer(key, value){ 
                return key.charAt(0) == '$' ? undefined : value;
            }
        }

        function transformResponse(response) {
            return angular.extend(response.resource, { $count: response.data.$count });
        }
    }
})();